export function isQuestionAnswered(answers) {
  return (
    answers &&
    answers.length > 0 &&
    answers.some((answer) => answer.text && answer.text.trim().length > 0)
  );
}
